var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00039 8.04844L1.92539 13.1234C1.79206 13.2568 1.62139 13.3274 1.41339 13.3354C1.20472 13.3441 1.02539 13.2734 0.875391 13.1234C0.725391 12.9734 0.650391 12.7984 0.650391 12.5984C0.650391 12.3984 0.725391 12.2234 0.875391 12.0734L5.95039 6.99844L0.875391 1.92344C0.742057 1.7901 0.671391 1.6191 0.663391 1.41044C0.654724 1.20244 0.725391 1.02344 0.875391 0.873437C1.02539 0.723437 1.20039 0.648438 1.40039 0.648438C1.60039 0.648438 1.77539 0.723437 1.92539 0.873437L7.00039 5.94844L12.0754 0.873437C12.2087 0.740104 12.3797 0.669104 12.5884 0.660438C12.7964 0.652438 12.9754 0.723437 13.1254 0.873437C13.2754 1.02344 13.3504 1.19844 13.3504 1.39844C13.3504 1.59844 13.2754 1.77344 13.1254 1.92344L8.05039 6.99844L13.1254 12.0734C13.2587 12.2068 13.3294 12.3774 13.3374 12.5854C13.3461 12.7941 13.2754 12.9734 13.1254 13.1234C12.9754 13.2734 12.8004 13.3484 12.6004 13.3484C12.4004 13.3484 12.2254 13.2734 12.0754 13.1234L7.00039 8.04844Z",
    fill: "#4D4184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.966399345e8a60eb7dd5bd09fad39d90.svg";
export { ForwardRef as ReactComponent };